import styled from '@emotion/styled';

const DecorateTitle = styled.h2`
  position: relative;
  left: -14px;
  padding-left: 14px;
  vertical-align: middle;
  line-height: 1.4;
  margin-bottom: 18px;
  font-size: 16px;
  color: var(--fett-text-primary);
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 1em;
    border-left: 4px solid var(--fett-app-primary-color);
    transform: translateY(-50%);
  }
  > .anticon-question-circle {
    margin-left: 8px;
    font-size: 14px;
    color: var(--fett-text-secondary);
    cursor: help;
  }
`;
export default DecorateTitle;
